import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postExecutionPhase2 } from '../Api'

export default generateApiAction({
  baseType: Types.EXECUTIONS.POST.P2,
  api: postExecutionPhase2,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/executions/PostPhase2Action.js